import React from 'react';

const Loader = ({rem = '3rem'}) => {
  return (
    <i className="pi pi-spin pi-spinner mr-3" style={{ fontSize: rem}} />
  );
};

export default Loader;